<template>
  <div>
    <paywall-upgrade-dialog
      v-if="upgradeDialog"
      :plans="plans"
      @close="upgradeDialog=false"
    />

    <v-switch
      v-if="!unlocked"
      :value="internalValue"
      readonly
      class="mt-0"
      v-bind="$attrs"
      :disabled="disabled"
      @click="click"
    >
      <template #label>
        <v-badge
          class="paywall-badge"
          :offset-x="16"
          :offset-y="-2"
          hidden
          icon="mdi-lock"
          :color="badgeColor"
        />
        <span class="d-block pl-2">{{ $attrs.label }}</span>
      </template>
    </v-switch>
    <v-switch
      v-else
      v-model="internalValue"
      class="mt-0"
      v-bind="$attrs"
      :disabled="disabled"
      @click="click"
    />
  </div>
</template>

<script setup lang="ts">
import {
  computed, PropType, ref, watch,
} from 'vue';
import PaywallUpgradeDialog from '@/components/dialogs/PaywallUpgradeDialog.vue';
import { useVuetify } from '../helpers/vue2-helpers';

const vuetify = useVuetify();

const props = defineProps({
  value: { type: undefined as any, required: true },
  unlocked: { type: Boolean, required: true },
  disabled: { type: Boolean, required: false, default: false },
  plans: { type: Array as PropType<('pro' | 'business' | 'ultimate')[]>, required: false, default: () => undefined },
});

const internalValue = ref(props.value);
watch(() => props.value, () => {
  internalValue.value = props.value;
});

const emit = defineEmits(['click', 'input']);

const upgradeDialog = ref(false);

const click = () => {
  if (props.unlocked) {
    emit('input', internalValue);
    return;
  }
  upgradeDialog.value = true;
};

const badgeColor = computed(() => {
  if (!props.disabled) return 'red';
  if (vuetify.theme.dark) return 'grey darken-3';
  return 'grey lighten-1';
});

</script>

<style lang="scss">
.paywall-badge .v-badge__badge .v-icon {
  padding-bottom: 2px;
}
</style>
